import SMTPConfig from './SMTPConfig.js'

export default SMTPConfig;
